/**************************************************
 * Nombre:       Home_PorQue_Elejirnos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {theme} from "../../../Tema";
import Tarjeta_Porque from "../../Tarjetas/Tarjeta_Porque";
import {NEGRITA} from "../../../Constantes";
import logo_ibero from '../../../Recursos/logo_ibero.png'
import ic_calidad from '../../../Recursos/ic_calidad.svg'
import ic_instalaciones from '../../../Recursos/ic_instalaciones.svg'
import ic_docentes from '../../../Recursos/ic_docentes.svg'

const Home_PorQue_Elejirnos = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}>

                <Grid
                    container
                    justifyContent={'flex-end'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 6}}
                    sx={{
                        backgroundColor: theme.palette.primary.main,
                        height: sCell ? 470 : 470
                    }}

                >


                </Grid>

                <Grid
                    container
                    justifyContent={'flex-end'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 6}}
                    sx={{
                        backgroundColor: theme.palette.info.main,
                        height: sCell ? 460 : 570
                    }}

                >


                </Grid>


            </Grid>


            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, mt: sCell ? -112 : -61}}
                spacing={2}
            >

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 11}}>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 5.5}}
                        spacing={3}
                    >

                        {items.map((item, index) => (
                            <Grid key={index + '9l'} container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Porque item={item}/>
                            </Grid>

                        ))}

                    </Grid>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 6.5}}
                        sx={{
                            border: 3,
                            borderColor: '#fff',
                            pt: sCell ? 8 : 4,
                            pb: sCell ? 14 : 4,
                            px: sCell ? 4 : 12,
                            color: '#fff',
                            mt: sCell ? 6 : 0
                        }}
                        spacing={0}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 40, fontWeight: 600, fontFamily: NEGRITA, lineHeight: 1.2}}>¿Por
                                qué
                                elegirnos?</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: sCell ? 22 : 24, fontWeight: 800}}>
                                Educación con Respaldo
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 16, fontWeight: 400, lineHeight: 1.2}}>
                                Formamos técnicos con ética y responsabilidad para el éxito en empresas públicas y
                                privadas.
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Typography sx={{fontSize: sCell ? 22 : 24, fontWeight: 800}}>
                                Continuidad educativa
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 16, fontWeight: 400, lineHeight: 1.2}}>
                                Integramos herramientas digitales y tendencias modernas para crear soluciones creativas
                                en
                                el mercado actual.
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                            <img src={logo_ibero} width={sCell ? '100%' : '54%'} height={'auto'}/>
                        </Grid>


                    </Grid>

                </Grid>


            </Grid>


        </Grid>
    )

}
export default Home_PorQue_Elejirnos

const items = [
    {
        nombre: 'Educación de Calidad',
        descripcion: 'Programas técnicos diseñados para brindar una formación integral, ética y de alta competitividad laboral',
        img: ic_calidad,
    },
    {
        nombre: 'Instalaciones Modernas',
        descripcion: 'Espacios equipados con tecnología de vanguardia para garantizar un aprendizaje práctico y actualizado',
        img: ic_instalaciones
    },
    {
        nombre: 'Docentes Expertos',
        descripcion: 'Contamos con instructores capacitados para guiar tu talento hacia la excelencia y la innovación profesional',
        img: ic_docentes
    },
]